import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { syncGuestData, fetchUserData } from "./sessionSlice"; // ✅ import from sessionSlice
import { storeUrl } from "../url";

axios.defaults.withCredentials = true;

// ✅ Check authentication using cookie
export const checkAuth = createAsyncThunk(
  "auth/checkAuth",
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(`${storeUrl}/auth`,{  withCredentials: true });
      return res.data.email;   
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Not authenticated");
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    email: null,
    isAuthenticated: false,
    loading: true,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.email = null;
      state.isAuthenticated = false;
      state.loading = false;
      axios.post(`${storeUrl}/logout`, {}, { withCredentials: true }).catch(() => {});
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkAuth.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkAuth.fulfilled, (state, action) => {
        state.email = action.payload;
        state.isAuthenticated = true;
        state.loading = false;

        // ✅ Automatically trigger syncGuestData after successful cookie login
        const email = action.payload;
        if (email) {
          const dispatch = thunkAPI => thunkAPI(dispatch(syncGuestData({ email })));
          // or simpler inside component
        }
      })
      .addCase(checkAuth.rejected, (state, action) => {
        state.email= null;
        state.isAuthenticated = false;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
